import moment from 'moment'

export default {
    namespaced: true,
    state: {
        dateType: 'single',
        departmentTab: 0,
        ytd: false,
        inactive: true,
        searchString: '',
        team: null,
        teams: {},
        year: parseInt (moment().format('YYYY')),
        startWeek: moment().week() > 1 ? moment().week() - 1 : moment().week(),
        endWeek: moment().week() > 1 ? moment().week() - 1 : moment().week(),
        years: Array.from(new Array(parseInt(moment().format('YYYY')) - 2018 + 1), (x, i) => i + 2018),
        complaintCategories: [],
        campaigns: null
    },
    getters: {
        teams: (state, getters) => [{ text: 'Alle teams', value: null }, ...(state.teams[getters.department] || [])],
        weeks: state => {
            const date = moment(state.year, 'YYYY')
            const endOfYearDate = date.endOf('year')
            const weeksInYear = Math.max(endOfYearDate.week(), endOfYearDate.subtract(1, 'week').week())
            return [...Array(weeksInYear).keys()].map(i => i + 1)
        },
        department: state => ['tryg', 'alka'][state.departmentTab]
    }
}